import { render, staticRenderFns } from "./DispatchedOrder.vue?vue&type=template&id=073538ea"
import script from "./DispatchedOrder.vue?vue&type=script&lang=js"
export * from "./DispatchedOrder.vue?vue&type=script&lang=js"
import style0 from "./DispatchedOrder.vue?vue&type=style&index=0&id=073538ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports